import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div>{t('footer.copyright')}</div>
      
      <div className="footer-links">
        <Link to="/privacy">
          {t('privacy.title')}
        </Link>
        <span> | </span>
        <Link to="/terms">
          {t('terms.title')}
        </Link>
        <span> | </span>
        <Link to="/refund">
          {t('refund.title')}
        </Link>
      </div>

      <div className="footer-contact">
        {t('footer.support')}{' '}
        <a href="https://t.me/diamondvpnsupport">SUPPORT</a>
      </div>
      
      <div className="footer-owner">
        {t('footer.owner')}
      </div>
    </footer>
  );
};

export default Footer;